import { t } from '@lingui/macro';
import { WeldDetailItemTab, WeldDetailItemTabType } from './types';

export const weldDetailItemTabList: WeldDetailItemTab[] = [
  { label: t`Summary`, value: WeldDetailItemTabType.SUMMARY },
  { label: t`Details`, value: WeldDetailItemTabType.DETAILS },
  { label: t`Photos`, value: WeldDetailItemTabType.PHOTOS },
  { label: t`Documents`, value: WeldDetailItemTabType.DOCUMENTS },
];
